import { gunterzBold } from '@/theme/fonts';
import { List, Text } from '@mantine/core';
export type GameIntroListItemProps = {
  title: string;
  des: string;
};
export const GameIntroListItem: React.FC<GameIntroListItemProps> = ({
  title,
  des
}) => {
  return <List.Item mt={20}>
      <Text fz="sm" c="var(--text-dark)" className={gunterzBold.className}>
        {title}
      </Text>
      <Text fz="xs" c="var(--text-dark)" fw={500}>
        {des}
      </Text>
    </List.Item>;
};